import { render, staticRenderFns } from "./lkuItemReceiptLazzy.vue?vue&type=template&id=efc5ce56"
import script from "./lkuItemReceiptLazzy.vue?vue&type=script&lang=js"
export * from "./lkuItemReceiptLazzy.vue?vue&type=script&lang=js"
import style0 from "./lkuItemReceiptLazzy.vue?vue&type=style&index=0&id=efc5ce56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports